import DesignerView from '@/views/designer/designer-view'

export default [
  {
    path: '/designer/:id',
    name: 'designer',
    component: DesignerView
  }
]



// WEBPACK FOOTER //
// ./src/router/designer/index.js